"use client";

import { Stub } from "@/composites/_internal";

/**
 * STUB — replaced in a subsequent ticket. See `docs/PDP_ARCHITECTURE.md`
 *
 * Intent: Renders variants[]; emits selected variant_sku. STORE-011.
 */
export function VariantSelector() {
	return (
		<Stub
			name="product/VariantSelector"
			intent="Renders variants[]; emits selected variant_sku. STORE-011."
		/>
	);
}
